export const validFeatureCategories = [
	'Accreditations',
	'Facilities',
	'Bills',
	'Safety and Security',
	'Rules',
];
